import { Divider, MenuItem, Stack } from "@mui/material"
import { X } from "react-feather"
import { MenuItemContainer } from "./MenuItemContainer"

export interface ResetOptionProps {
  label?: string
  onReset: () => void
}

export const ResetOption = ({
  label = "Réinitialiser les filtres",
  onReset,
}: ResetOptionProps) => (
  <MenuItemContainer>
    <MenuItem onClick={onReset} sx={{ px: 3, py: 1.5 }}>
      <Stack direction="row" alignItems="center" gap={1} sx={{ width: "100%" }}>
        <X size={16} />
        {label}
      </Stack>
    </MenuItem>
    <Divider sx={{ m: "0 !important" }} />
  </MenuItemContainer>
)
